import type { AuthContextUser } from 'contexts';
import { PlanName } from 'contexts/modal/types';
import type { Plan } from '@bb/automaton';
import { OrgStatus } from '../Router/onboarding/constants';
import isFullAccessUser from './isFullAccessUser';

/**
 * Users in an unclaimed org on the brokerage plan have limited access to certain
 * features, particularly listing-related features
 *
 * @see {@link https://brokerbay.atlassian.net/browse/ENG-8664 ENG-8664}
 */
const isLimitedAccessOnUnclaimedBrokerage = (
  auth: AuthContextUser,
  orgStatus: OrgStatus | null,
  orgPlan: Pick<Plan, 'name'> | undefined | null,
) =>
  !isFullAccessUser(auth) &&
  orgStatus === OrgStatus.UNCLAIMED &&
  orgPlan?.name === PlanName.BROKERAGE;

export default isLimitedAccessOnUnclaimedBrokerage;
